import SocketController from './Socket';

export default new SocketController('backendSocket');
